// Mock data for Template 4 real estate website
export const mockRootProps = {
  businessInfo: {
    name: "realtic",
    logo: "/images/realtic-logo.png",
    heroTitle: "Find Your Dream Home",
    heroSubtitle: "Explore our comprehensive listings of residential properties, from cozy starter homes to luxurious estates.",
    ctaText: "Browse Now",
    heroBackgroundImage: "/images/real-estate-hero.jpg"
  },
  navigation: {
    menuItems: ["Home", "Blogs", "About Us", "Reviews"]
  },
  aboutUs: {
    sectionLabel: "Who we are",
    title: "Lorem ipsum dolor sit amet,",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas faucibus, nunc consequat cursus cursus, urna diam euismod arcu, etLorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas faucibus, nunc consequat cursus cursus, urna diam euismod arcu, et iaculis turpis sapien quis velit. Nam maximus lectus eu consequat pulvinar. Duis porttitor euismod. iaculis turpis sapien quis velit. Nam maximus lectus eu consequat Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet,",
    image: "/images/real-estate-about.jpg"
  },
  services: [
    {
      id: 1,
      title: "Lorem ipsum",
      description: "Phosfluorecent synergize holistic leadership skills before effective technology.In the digital era, where technology is rapidly…",
      image: "/images/real-estate-service-1.jpg"
    },
    {
      id: 2,
      title: "Lorem ipsum", 
      description: "Phosfluorecent synergize holistic leadership skills before effective technology.In the digital era, where technology is rapidly…",
      image: "/images/real-estate-service-2.jpg"
    },
    {
      id: 3,
      title: "Lorem ipsum",
      description: "Phosfluorecent synergize holistic leadership skills before effective technology.In the digital era, where technology is rapidly…",
      image: "/images/real-estate-service-3.jpg"
    },
    {
      id: 4,
      title: "Lorem ipsum",
      description: "Phosfluorecent synergize holistic leadership skills before effective technology.In the digital era, where technology is rapidly…",
      image: "/images/real-estate-service-1.jpg"
    },
    {
      id: 5,
      title: "Lorem ipsum",
      description: "Phosfluorecent synergize holistic leadership skills before effective technology.In the digital era, where technology is rapidly…",
      image: "/images/real-estate-service-2.jpg"
    },
    {
      id: 6,
      title: "Lorem ipsum",
      description: "Phosfluorecent synergize holistic leadership skills before effective technology.In the digital era, where technology is rapidly…",
      image: "/images/real-estate-service-3.jpg"
    }
  ],
  testimonials: [
    {
      id: 1,
      name: "Adam S",
      company: "Google",
      review: "Working with Realty was a dream come true! We found our perfect home faster than we expected, and the process was smooth from start to finish.",
      avatar: "/images/testimonial-avatar.png",
      rating: 5
    }
  ],
  faq: [
    {
      id: 1,
      question: "What is the first step in the home buying process?",
      answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      isExpanded: true
    },
    {
      id: 2,
      question: "How long does it take to buy a home?",
      answer: null,
      isExpanded: false
    },
    {
      id: 3,
      question: "What is an escrow account?",
      answer: null,
      isExpanded: false
    },
    {
      id: 4,
      question: "What is a contingency in a real estate contract?",
      answer: null,
      isExpanded: false
    }
  ],
  blogs: [
    {
      id: 1,
      title: "Invest in Property",
      description: "Phosfluorecent synergize holistic leadership skills before effective technology.In the digital era, where technology is rapidly…",
      image: "/images/real-estate-service-1.jpg"
    },
    {
      id: 2,
      title: "Invest in Property",
      description: "Phosfluorecent synergize holistic leadership skills before effective technology.In the digital era, where technology is rapidly…",
      image: "/images/real-estate-service-2.jpg"
    },
    {
      id: 3,
      title: "Invest in Property", 
      description: "Phosfluorecent synergize holistic leadership skills before effective technology.In the digital era, where technology is rapidly…",
      image: "/images/real-estate-service-3.jpg"
    }
  ],
  footer: {
    logo: "/images/realtic-logo.png",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit eta dolore magna.",
    socialMedia: {
      facebook: "#",
      twitter: "#",
      youtube: "#"
    },
    sections: {
      services: {
        title: "Services",
        links: ["Real Estate Agents", "Home Measurement", "Consultation", "Buying", "Selling"]
      },
      company: {
        title: "Company", 
        links: ["About", "Partnership", "Features", "Testimonials", "Media Center", "Career"]
      },
      links: {
        title: "Links",
        links: ["Our Clients", "Contact", "Help Center", "Blog"]
      }
    },
    copyright: {
      brand: "Visibeen",
      text: "Powered by Visibeen.",
      links: ["Privacy Policy", "Our Terms"]
    }
  },
  location: {
    title: "Find Us",
    subtitle: "Visit our location or reach out to us for more information",
    address: "Real Estate Services Location"
  }
};